module.exports = __webpack_public_path__ + "static/img/light.094e2482.png";